export interface Availability {
  id: string;
  weekday: string;
  startTime: string;
  endTime: string;
  type: 'work' | 'dropoff';
}

export type CreateAvailability = Omit<Availability, 'id'>;

export const InitialDropOffSchedule: Pick<Availability, 'weekday' | 'startTime' | 'endTime'> = {
  weekday: 'Monday',
  startTime: '00:00',
  endTime: '00:00',
};

export interface PagedAvailability {
  type?: string;
}

export const weekdays = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

export const weekdayLabels = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const weekdayMap = {
  0: 'Monday',
  1: 'Tuesday',
  2: 'Wednesday',
  3: 'Thursday',
  4: 'Friday',
  5: 'Saturday',
  6: 'Sunday',
};
